import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=9264de18&scoped=true&"
import script from "./viewDetail.vue?vue&type=script&lang=js&"
export * from "./viewDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewDetail.vue?vue&type=style&index=0&id=9264de18&prod&scoped=true&lang=scss&"
import style1 from "./viewDetail.vue?vue&type=style&index=1&id=9264de18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9264de18",
  null
  
)

export default component.exports